import { render, staticRenderFns } from "./ai_detection_flag.vue?vue&type=template&id=68e87b6f&scoped=true&"
import script from "./ai_detection_flag.vue?vue&type=script&lang=js&"
export * from "./ai_detection_flag.vue?vue&type=script&lang=js&"
import style0 from "./ai_detection_flag.vue?vue&type=style&index=0&id=68e87b6f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e87b6f",
  null
  
)

export default component.exports